'use strict';

import template from './mx-shell.component.html';

export const shellComponent = {
	template: template,
	controller: ShellComponentController,
	controllerAs: 'vm',
};
angular.module('mx.shell').component('mxShell', shellComponent);

/**
 * @ngdoc controller
 * @name mx.shell.Controller
 * @module mx.shell
 *
 * @description
 * Sets shell variables. E.g. Pages urls
 * @requires {@ref mx.shell.EventService mx.shell.EventService}
 */
ShellComponentController.$inject = [
	'$timeout',
	'$element',
	'mx.shell.EventService',
	'mx.shell.SideLayout',
	'$window',
	'mx.shell.AppsService',
	'mx.shell.RoutingService',
	'mx.app.ThemeService',
	'mx.shell.ExtraPanelManager',
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.DeepLinkingService',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'$scope',
];

export function ShellComponentController(
	$timeout,
	$element,
	eventService,
	mxSideLayout,
	$window,
	appsService,
	routingService,
	themeService,
	mxExtraPanelManager,
	searchProviderService,
	deepLinkingService,
	personalizationService,
	$scope
) {
	const vm = this;

	vm.mxSideLayout = mxSideLayout;
	vm.mxExtraPanelManager = mxExtraPanelManager;
	vm.searchProviderService = searchProviderService;

	vm.$onInit = async function () {
		vm.shell = window.mx.shell;

		vm.routingService = routingService;

		initApp();

		themeService.getCurrentColors().then((res) => {
			mx.currentThemeColors = res;

			mx.currentThemeColorsObj = mx.currentThemeColors.reduce((themeObj, item) => {
				themeObj[item.Key] = item.Value;
				return themeObj;
			}, {});
		});

		mx.isEnhancedColorContrastMode = await personalizationService.getEnhancedColorContrastMode();
	};

	eventService.subscribeTo(mx.shell.EventCodes.RouteActivated, () => configureUnifiedSearch(), $scope);

	eventService.subscribeTo(mx.shell.EventCodes.GlobalSearchConfigChanged, () => configureUnifiedSearch(), $scope);

	function configureUnifiedSearch() {
		if (vm.app.unifiedSearchEnabled) {
			const currentRoute = vm.routingService.getCurrent();
			if (vm.currentRoute === currentRoute) {
				return;
			}
			$scope.$applyAsync(() => {
				vm.currentRoute = currentRoute;
				vm.currentRouteName = vm.currentRoute.name;
				vm.openedViaDirectLink = !!deepLinkingService.parseViewOptionsFromUrl();

				if (
					(typeof vm.unifiedSearchHiddenByScroll === 'undefined' || vm.unifiedSearchHiddenByScroll === true) &&
					vm.currentRouteName === 'landingPage' &&
					!vm.openedViaDirectLink
				) {
					vm.unifiedSearchHiddenByScroll = false;
					vm.mainZoneEl = vm.mainZoneEl || $element.find('.mx-main-content-zone')[0];
					vm.mainZoneEl.addEventListener('scroll', collapseUnifiedSearchByScroll, true);
				} else if (vm.unifiedSearchHiddenByScroll === false && vm.currentRouteName !== 'landingPage') {
					vm.unifiedSearchHiddenByScroll = undefined;
					vm.mainZoneEl.removeEventListener('scroll', collapseUnifiedSearchByScroll, true);
				}
			});
		}
	}

	function collapseUnifiedSearchByScroll() {
		if (!vm.unifiedSearchHiddenByScroll) {
			$timeout(() => {
				vm.unifiedSearchHiddenByScroll = true;
			});
			vm.mainZoneEl.removeEventListener('scroll', collapseUnifiedSearchByScroll, true);
		}
	}

	// If "window resize" event is triggered then `mx.shell.EventCodes.LayoutChanged` will be triggered as well.
	// And vice versa - If `mx.shell.EventCodes.LayoutChanged` is triggered (for example mxSidePanel is opened) then we need to trigger "window resize" event.
	// It's needed for proper setting `mx-grid` sized (`mx-grid` is listening "window resize" event) and, probably can be usefull for some other Components.
	// So, just by subscribing to `mx.shell.EventCodes.LayoutChanged` event - we will be know about all changes of PandoraShell Layaut and about window resizing too.
	var _isManualWindowResizeTriggering;
	$($window).on('resize', function () {
		if (_isManualWindowResizeTriggering) {
			_isManualWindowResizeTriggering = false;
		} else {
			vm._debouncedLayoutChangeDispatcherResize();
		}
	});
	vm._debouncedLayoutChangeDispatcherResize = $.debounce(100, function () {
		eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged, '__triggeredByWindowResize__');
	});

	vm.debouncedLayoutChangeDispatcherExtraPanel = $.debounce(100, function () {
		eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged, 'mxExtraPanelResized');
	});

	eventService.subscribeTo(
		mx.shell.EventCodes.LayoutChanged,
		function (ev, param) {
			if (param !== '__triggeredByWindowResize__') {
				_isManualWindowResizeTriggering = true;
				$($window).trigger('resize');
			}
		},
		$scope
	);

	async function initApp() {
		vm.app = await appsService.getCurrentApplication();

		if (vm.app.unifiedSearchEnabled) {
			eventService.subscribeGlobal(mx.shell.EventCodes.SidePanelVisibility, function (e, visible) {
				vm.SidePanelVisible = visible;
			});
		}
	}
}
